import { InjectionToken } from '@angular/core';

export interface IOption {
  code?: string,
  codeValue?: string,
  message?: string,
  data?: string,
  header?: string;
}

export const HTTP_CONFIG = new InjectionToken<IOption>('HTTP_CONFIG');